import { useTranslation } from 'react-i18next';
import './styles.scss';

interface FooterTitleProps {
	title: string;
}

export const FooterTitle: React.FC<FooterTitleProps> = (props: FooterTitleProps) => {
	const { t } = useTranslation();
	const { title } = props;
	return <h3 className="footerTitle">{t(title)}</h3>;
};
export default FooterTitle;
